import { IExistingRelation, IMergedRow } from "../../models";

export const flattenExistingRelation = (
  existingRelation: IExistingRelation,
  rowsDictionary: Record<number, string>,
): IMergedRow[] => {
  const result: IMergedRow[] = [];

  for (const [id, relations] of Object.entries(existingRelation)) {
    for (const [relation, items] of Object.entries(relations)) {
      result.push({
        id,
        relation,
        ids: items.map(item => item.id),
        name: rowsDictionary[+id],
      });
    }
  }

  return result;
};

export const buildRelationRowsDictionary = (
  rows?: { id: number; name?: string }[],
): Record<number, string> => {
  const dict: Record<number, string> = {};
  for (const row of rows ?? []) {
    dict[row.id] = row?.name ?? "";
  }
  return dict;
};
